<template>
  <form class="row" @submit.prevent="createChannel()">
    <div class="small-12 medium-8 columns">
      <label :class="{ error: $v.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
        <input
          v-model.trim="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
          @blur="$v.inboxName.$touch"
        />
        <span v-if="$v.inboxName.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.ERROR') }}
        </span>
      </label>
    </div>

    <div class="small-12 medium-12 columns">
      <woot-submit-button
        :loading="isLoading"
        :button-text="$t('INBOX_MGMT.ADD.WHATSAPP.SUBMIT_BUTTON')"
        :disabled="isLoading"
      />
    </div>


  </form>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import { required } from 'vuelidate/lib/validators';
import router from '../../../../index';
import InboxApi from 'dashboard/api/inboxes.js'

export default {
  mixins: [alertMixin],
  data() {
    return {
      inboxName: '',
      isLoading:false,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
      globalConfig: 'globalConfig/get',
    }),
  },
  validations: {
    inboxName: { required },
    // phoneNumber: { required, shouldStartWithPlusSign },
    // apiKey: { required },
  },
  mounted(){
    this.$nextTick(()=>{
      const inboxName = sessionStorage.getItem('whatsapp_personal_inbox_name');
      if (inboxName) {
        this.inboxName = inboxName;
      }
    })
  },
  methods: {
    async createChannel() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      try {
        this.isLoading = true;
        const {data} = await InboxApi.generateWaPersonalQR({ name: this.inboxName })
        sessionStorage.setItem("whatsapp_personal_inbox_name",this.inboxName);
        sessionStorage.setItem("whatsapp_personal_QR",data.qr);
        // sessionStorage.setItem("whatsapp_personal_QR",demoQR);
        // go to scan QR code
        this.isLoading = false;
        router.replace({
          name: 'whatsapp_inbox_scan_qr',
          params: {
            page: 'new',
            // inbox_id: whatsappChannel.id,
            sub_page: 'whatsapp_personal',
          },
        });
      } catch (error) {
        this.showAlert(error.response?.data?.message || this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ERROR_MESSAGE'));
        this.isLoading = false;
      }
    },
  },
}
</script>

<style>

</style>